import { useContext, useEffect, useRef } from "react";
import olMap from "ol/Map";
import MapContext from "../map/MapContext";

export interface ViewResolutionChangeProps {
  onResolutionChange: (zoom: number) => void;
}

const ViewResolutionChange = ({
  onResolutionChange,
}: ViewResolutionChangeProps) => {
  const map = useContext(MapContext) as olMap;

  const onResolutionChangeRef = useRef(onResolutionChange);
  useEffect(() => {
    onResolutionChangeRef.current = onResolutionChange;
  }, [onResolutionChange]);

  useEffect(() => {
    if (!map) return;
    const view = map.getView();

    const handler = () => {
      const zoom = view.getZoom();
      if (zoom !== undefined) onResolutionChangeRef.current(zoom);
    };

    view.on("change:resolution", handler);
    return () => {
      view.un("change:resolution", handler);
    };
  }, [map]);

  return null;
};

export default ViewResolutionChange;
